import {
  PUB_SUB_CHANNEL_APP,
  PUB_SUB_CHANNEL_MODAL,
} from '@wix/communities-blog-client-common/dist/src/constants/pub-sub-channels';
import { isEditor } from '../selectors/view-mode-selectors';
import { isMobile } from '../services/wix-sdk-utils';
import { isInWix } from '../services/is-in-wix';
import { showModal } from './show-modal';
import { openWixModal } from './open-wix-modal';

export const openModal = (payload, focusOnCloseId) => (dispatch, getState) => {
  const state = getState();
  const isMembersExtension = state.isMembersExtension;

  if (!isMembersExtension) {
    dispatch(
      showModal(payload, {
        focusOnCloseId,
        publish: [PUB_SUB_CHANNEL_APP, PUB_SUB_CHANNEL_MODAL],
      }),
    );
  } else {
    dispatch(showModal(payload, { focusOnCloseId }));
    if (!isMobile() && isInWix() && !isEditor(getState())) {
      dispatch(
        openWixModal({
          ...payload,
          isMembersExtension,
        }),
      );
    }
  }
};
